import { Action } from "../../../libs/redux/action";
import { quotationDefaultState, QuotationState } from "../state";
import {
    CALCULATE_QUOTATION,
    CALCULATE_QUOTATION_DONE,
    CLEAR_QUOTATION,
    HIDE_QUOTATION_LOADING,
    LOADING_QUOTATION,
    QUOTATION_GET_PRE_QUOTATION_VALUES,
    QUOTATION_GET_PRE_QUOTATION_VALUES_DONE,
    QUOTATION_IS_VALID,
    QUOTATION_SELECT_PRIME,
    SAVE_QUOTATION,
    SAVE_QUOTATION_DONE,
    UPDATE_INITIAL_MONTH_QUOTATION,
} from "../constants";
import {
    Prime,
    QuotationCalculated,
    QuotationParams,
    QuotationValues,
    SaveQuotationValues,
} from "../../../containers/quotation/types/quotation";
import { TypeRates } from "../../../constants/enums/quotation";

export class QuotationGetPreQuotationValues extends Action<
    QuotationParams,
    QuotationState
> {
    readonly type = QUOTATION_GET_PRE_QUOTATION_VALUES;

    reducer(state: QuotationState): QuotationState {
        return {
            ...state,
        };
    }
}

export class QuotationGetPreQuotationValuesDone extends Action<
    Error | QuotationValues,
    QuotationState
> {
    readonly type = QUOTATION_GET_PRE_QUOTATION_VALUES_DONE;

    reducer(state: QuotationState): QuotationState {
        if (this.error) {
            return {
                ...state,
                annual: null,
                semester: null,
            };
        }
        const payloadTyped = this.payload as QuotationValues;

        const annualPrime = payloadTyped.additionsSelected.find(
            (prime: Prime) => prime.typeRate === TypeRates.ANNUAL
        );

        const semesterPrime = payloadTyped.additionsSelected.find(
            (prime: Prime) => prime.typeRate === TypeRates.SEMESTER
        );

        return {
            ...state,
            annual: annualPrime,
            semester: semesterPrime,
            workersRange: payloadTyped.workersRange,
        };
    }
}

export class QuotationCalculate extends Action<
    { fileName: string; typeRate: TypeRates },
    QuotationState
> {
    readonly type = CALCULATE_QUOTATION;

    reducer(state: QuotationState): QuotationState {
        return {
            ...state,
        };
    }
}

export class QuotationCalculateDone extends Action<
    Error | QuotationCalculated,
    QuotationState
> {
    readonly type = CALCULATE_QUOTATION_DONE;

    reducer(state: QuotationState): QuotationState {
        if (this.error) {
            return {
                ...state,
            };
        }

        const { typeRate } = this.payload as QuotationCalculated;

        return {
            ...state,
            calculated: {
                ...state.calculated,
                [typeRate]: this.payload as QuotationCalculated,
            },
        };
    }
}

export class UpdateInitialMonthQuotation extends Action<
    string,
    QuotationState
> {
    readonly type = UPDATE_INITIAL_MONTH_QUOTATION;

    reducer(state: QuotationState): QuotationState {
        return {
            ...state,
            initialMonth: this.payload,
        };
    }
}

export class QuotationIsValid extends Action<Error | void, QuotationState> {
    readonly type = QUOTATION_IS_VALID;

    reducer(state: QuotationState): QuotationState {
        if (this.error) {
            return {
                ...state,
                isAbleToContinue: false,
            };
        }

        return {
            ...state,
            isAbleToContinue: true,
        };
    }
}

export class QuotationSelectPrime extends Action<TypeRates, QuotationState> {
    readonly type = QUOTATION_SELECT_PRIME;

    reducer(state: QuotationState): QuotationState {
        return {
            ...state,
            primeSelected: this.payload,
        };
    }
}

export class SaveQuotation extends Action<SaveQuotationValues, QuotationState> {
    readonly type = SAVE_QUOTATION;

    reducer(state: QuotationState): QuotationState {
        return {
            ...state,
            showLoading: true,
        };
    }
}

export class SaveQuotationDone extends Action<any, QuotationState> {
    readonly type = SAVE_QUOTATION_DONE;

    reducer(state: QuotationState): QuotationState {
        return {
            ...state,
        };
    }
}

export class HideQuotationLoading extends Action<void, QuotationState> {
    readonly type = HIDE_QUOTATION_LOADING;

    reducer(state: QuotationState): QuotationState {
        return {
            ...state,
            showLoading: false,
        };
    }
}

export class ClearQuotation extends Action<void, QuotationState> {
    readonly type = CLEAR_QUOTATION;

    reducer(state: QuotationState): QuotationState {
        return {
            ...state,
            ...quotationDefaultState,
        };
    }
}

export class LoadingQuotation extends Action<
    SaveQuotationValues,
    QuotationState
> {
    readonly type = LOADING_QUOTATION;

    reducer(state: QuotationState): QuotationState {
        return {
            ...state,
            showLoading: true,
        };
    }
}
